export default __webpack_public_path__ + "static/media/Opposites03_08.348c8004.png";